import { Controller } from 'stimulus';
import { post } from '@rails/request.js';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static values = {
    url: String,
    trackableClass: String,
    trackableAction: String,
  };

  #tracked = false;

  track() {
    if (this.#tracked || !this.urlValue) {
      return;
    }

    this.#tracked = true;

    post(this.urlValue, {
      body: {
        trackable_class: this.trackableClassValue,
        trackable_action: this.trackableActionValue,
      },
      responseKind: 'turbo-stream',
    }).then((response) => {
      if (response.ok && response.contentType?.includes('turbo-stream')) {
        response.text.then((html) => Turbo.renderStreamMessage(html));
      }
    });
  }
}
